// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1XQCG","assignButton":"CreateEditEquipmentSchedule_assignButton__3PUMG"};